export const FIXTURE_STATUS = {
  scheduled: ['NS', 'TBD'] as const,
  live: ['1H', 'HT', '2H', 'ET', 'BT', 'P', 'INT', 'LIVE'] as const,
  completed: ['FT', 'AET', 'PEN'] as const,
  stopped: ['PST', 'CANC', 'ABD', 'SUSP', 'AWD', 'WO'] as const,
} as const;

export const COMPLETED_STATUSES = [...FIXTURE_STATUS.completed] as string[];
export const LIVE_STATUSES = [...FIXTURE_STATUS.live] as string[];
export const SCHEDULED_STATUSES = [...FIXTURE_STATUS.scheduled] as string[];
export const STOPPED_STATUSES = [...FIXTURE_STATUS.stopped] as string[];
// Mirrors MATCHDAY_DONE_STATUSES in supabase/functions/_shared/canonical-types.ts
export const FINISHED_STATUSES = [...COMPLETED_STATUSES, ...STOPPED_STATUSES.filter(s => s !== 'SUSP')];

const completedSet = new Set<string>(FIXTURE_STATUS.completed);
const liveSet = new Set<string>(FIXTURE_STATUS.live);
const scheduledSet = new Set<string>(FIXTURE_STATUS.scheduled);
const stoppedSet = new Set<string>(FIXTURE_STATUS.stopped);
const finishedSet = new Set<string>(FINISHED_STATUSES);

export function isCompleted(status: string): boolean {
  return completedSet.has(status);
}

export function isLive(status: string): boolean {
  return liveSet.has(status);
}

export function isScheduled(status: string): boolean {
  return scheduledSet.has(status);
}

export function isStopped(status: string): boolean {
  return stoppedSet.has(status);
}

export function isFinished(status: string): boolean {
  return finishedSet.has(status);
}
